// extracted by mini-css-extract-plugin
module.exports = {"offers":"_2FWGGv","offer":"E3s2Il","cueOrange":"NMWNgw"};